import styled from '../../styled-components';

export const Iframe = styled.iframe`
  display: block;
  width: 100%;
  height: 100%;
  margin: 0;
  border: 0;
`;
